import { Metadata } from 'next';
import InsuranceTermsListClient from './client';

export const metadata: Metadata = {
    title: '약관 관리 - InsuWiki Admin',
    description: '보험 약관 3단계 요약 관리',
};

export default function InsuranceTermsPage() {
    return (
        <div className="min-h-screen bg-slate-50">
            <div className="max-w-4xl mx-auto px-4 py-8">
                <div className="mb-6">
                    <h1 className="text-2xl font-bold text-slate-800">약관 관리</h1>
                    <p className="text-sm text-slate-500 mt-1">
                        보험 약관 3단계 요약 (핵심 / 섹션 / 원문)
                    </p>
                </div>
                <InsuranceTermsListClient />
            </div>
        </div>
    );
}
